export default __webpack_public_path__ + "static/media/simone.aa27ee1f.png";